module.exports = __webpack_public_path__ + "assets/img/ali_pay.4e485cf5.svg";